import BaseService from "src/packages/BaseService";

export default class GameLogService extends BaseService {
	static get className() {
		return "gamelog";
	}
};
